
        require('./index.scss');
        'use strict';

var $ = window.$;
var $mod = $('.module-brand-recomd');
var lazyLoad = require('assets/util/lazy-load.js');
var $ = window.$;

var PicSwitch = function PicSwitch(config) {
    this.ele = config.ele;
    this.leftBtn = config.leftBtn;
    this.rightBtn = config.rightBtn;
    this.dotBtn = config.dotBtn;
    this.page = 0;
    this.total = this.ele.find('.info-count').length;
};

PicSwitch.prototype = {
    init: function init() {
        this.animate(0);
        this.event();
    },
    event: function event() {
        var _this = this,
            tSwitch,
            li = _this.ele.find('.info-count');

        function switchFun() {
            if (_this.page >= _this.total - 1) {
                _this.page = -1;
            }
            _this.page++;
            _this.animate(_this.page);
        }
        tSwitch = setInterval(switchFun, 3000);

        _this.ele.hover(function () {
            _this.rightBtn.css('display', 'block');
            _this.leftBtn.css('display', 'block');
            clearInterval(tSwitch);
        }, function () {
            _this.rightBtn.css('display', 'none');
            _this.leftBtn.css('display', 'none');
            tSwitch = setInterval(switchFun, 3000);
        });

        if (typeof this.rightBtn !== 'undefined') {
            this.rightBtn.click(function (event) {
                event.preventDefault();
                clearInterval(tSwitch);
                if (_this.page >= _this.total - 1) {
                    _this.page = -1;
                }
                _this.page++;
                _this.animate(_this.page);
            });
        }

        if (typeof this.leftBtn !== 'undefined') {
            this.leftBtn.click(function (event) {
                event.preventDefault();
                clearInterval(tSwitch);
                if (_this.page <= 0) {
                    _this.page = _this.total;
                }
                _this.page--;
                _this.dotBtn.removeClass('cur');
                _this.animate(_this.page);
            });
        }

        this.dotBtn.click(function (event) {
            var index;
            event.preventDefault();
            clearInterval(tSwitch);
            if ($(this).hasClass('active')) {
                return;
            }
            index = $(this).index();
            _this.page = index;
            _this.animate(_this.page);
            tSwitch = setInterval(switchFun, 3000);
        });
    },
    animate: function animate(page) {
        var li = this.ele.find('.info-count'),
            _this = this;
        this.dotBtn.removeClass('active');
        $(this.dotBtn[page]).addClass('active');
        li.hide();
        $(li[page]).css('opacity', 0.3).show().animate({
            'opacity': 1
        }, 800);
    },
    lazyLoadImg: function lazyLoadImg($temp) {
        if ($temp.hasClass('lazy-load-img')) {
            $temp.attr('src', $temp.data('lazy_src'));
            $temp.removeClass('lazy-load-img');
        }
    }

};

var _module = {
    init: function init() {
        var secSwitch = new PicSwitch({
            'ele': $mod.find('.info-block'),
            'leftBtn': $mod.find('.banner-left'),
            'rightBtn': $mod.find('.banner-right'),
            'dotBtn': $mod.find('.dots .dot')
        });
        secSwitch.init();
        if (lazyLoad && typeof lazyLoad == 'function') {
            lazyLoad('.module-brand-recomd', '.homeBrand');
        }
    },
    tagChange: function tagChange() {
        $mod.find('.nav-item-group').click(function (e) {
            var $target = $(e.target);
            var index = $target.index();
            $target.addClass('tab-nav-active').siblings().removeClass('tab-nav-active');
            $mod.find('.info-count').removeClass('active').eq(index).addClass('active');
        });
    }
};

_module.init();;
    


// WEBPACK FOOTER //
// ./src/module/home-index/brand-recomd/index.js